import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import styles from "./SourceSet.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var SourceSet = function SourceSet(_ref) {
  var children = _ref.children;
  var numberToClassname = function numberToClassname(number, postfix) {
    var numberClassnames = ['one', 'two', 'three'];
    return "".concat(numberClassnames[number - 1]).concat(postfix);
  };
  var childrenCount = function childrenCount() {
    var count = 0;
    React.Children.forEach(children, function (child) {
      if (child) {
        count++;
      }
    });
    return count;
  };
  var count = childrenCount();

  // If we don't have any items, return nothing.
  if (!count) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles[numberToClassname(count, 'Items')],
    children: React.Children.map(children, function (child, i) {
      if (child) {
        return /*#__PURE__*/_jsx("div", {
          className: styles[numberToClassname(i + 1, 'X')],
          children: child
        }, i);
      }
      return null;
    })
  });
};